// PO1-3915: ordem da lista de propostas da Nova Cotação — por valor, mas quem
// está acima da capacidade do veículo (a tabela cotou um veículo que não leva
// o peso) vai para o fim. Continua selecionável; só não aparece como "melhor".
//
// Não altera a lista recebida: a tela guarda `proposals` e `spots` em estado.
export function ordenarPropostas(lista) {
  return [...(Array.isArray(lista) ? lista : [])].sort((a, b) => {
    const ca = a && a.acimaCapacidade ? 1 : 0;
    const cb = b && b.acimaCapacidade ? 1 : 0;
    if (ca !== cb) return ca - cb;
    return (Number(a && a.valor) || 0) - (Number(b && b.valor) || 0);
  });
}

export default ordenarPropostas;
